module.exports = __webpack_public_path__ + "img/ferienhaus_debontje_greetsiel_schlafzimmer_unten_01.1ce6fca5.jpg";